<template>
  <a-layout>
    <a-space>
      <vxe-input v-model="args['zone.no']" placeholder="business.label.workstation" @clear="refresh" @keydown.native.enter="refresh"/>
      <vxe-input v-model="args['container.no']" placeholder="business.label.containerNo" @clear="refresh" @keydown.native.enter="refresh"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :height="scrollY"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      style="margin-top: 2px"
      @cell-dblclick="({row})=>dblclick(row)">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="zone.no" title="business.label.workstation" />
      <vxe-column field="container.no" title="business.label.containerNo" width="90" />
      <vxe-column field="customer.no" title="business.label.customerNo" />
      <vxe-column field="customer.name" title="business.label.customerName" />
      <vxe-column field="container.operationType" title="business.label.operationType">
        <span slot-scope="{ row }">{{ operationTypes.find(item => item.ordinal === row.container.operationType).name }}</span>
      </vxe-column>
    </vxe-table>
    <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
  </a-layout>
</template>
<script>
import Vue from 'vue'
import { findAll, findEnum } from '@/api/Api'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
    name: 'ViewSeedingTaskTable',
    data() {
      return {
        loading: false,
        page: 1,
        size: 20,
        contentSize: 0,
        args: {
          'positionType.id': this.positionTypeId,
          'container.no': '',
          'zone.no': ''
        },
        data: [],
        operationTypes: [],
        scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.77)// 表格竖向滚动条,减去的数值是页面其他元素的高度
      }
    },
    mounted() {
      findEnum('OperationType').then(res => {
        if (res.success) {
          this.operationTypes = res.result
        }
      })
      this.fetch()
    },
    props: {
      positionTypeId: {
        type: String,
        default: ''
      }
    },
    methods: {
      pageChange({ currentPage, pageSize }) {
        this.page = currentPage
        this.size = pageSize
        this.fetch()
      },
      fetch() {
        this.loading = true
        findAll('seedingListFactory', this.args, this.page, this.size).then(res => {
          if (res.success) {
            this.contentSize = res.contentSize
            this.data = res.result
          }
        }).finally(() => this.loading = false)
      },
      refresh() {
        this.page = 1
        this.fetch()
      },
      reset() {
        this.page = 1
        this.args['zone.no'] = ''
        this.args['container.no'] = ''
        this.fetch()
      },
      dblclick(row) {
        this.$emit('dblclick', row)
      }
    }
  }
</script>